"use strict";
// cond - short for conditional - is an n-ary version of the trinary operator
//
// Wikipedia: https://en.wikipedia.org/wiki/Lisp_(programming_language)#Control_structures
//
// Example usage:
//
// const style = ({ isErrored, isSelected }) => ({
//   backgroundColor: cond(
//     [isSelected, Colors.blue500],
//     [isErrored, Colors.red100],
//     Colors.storm
//   )
// });
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var passes = function (condition) {
    if (Array.isArray(condition)) {
        var _a = __read(condition, 1), test_1 = _a[0];
        return ((test_1 instanceof Function && test_1.apply(null)) ||
            (test_1 && !(test_1 instanceof Function)));
    }
    return condition;
};
var value = function (condition) {
    if (Array.isArray(condition)) {
        var _a = __read(condition, 2), val = _a[1];
        return val;
    }
    return condition;
};
var cond = function () {
    var conditions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        conditions[_i] = arguments[_i];
    }
    return (conditions && value(conditions.find(passes))) ||
        value(conditions[conditions.length - 1]);
};
exports.default = cond;
